import type React from "react";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useSidebar } from "./SidebarContext";
import type { IThemeState } from "../../types/theme";
import { tokens } from "../../theme";

interface CollapseButtonProps {
  theme: IThemeState;
}

export const CollapseButton: React.FC<CollapseButtonProps> = ({ theme }) => {
  const muiTheme = useTheme();
  const colors = tokens(muiTheme.palette.mode, theme);
  const { isCollapsed, toggleCollapse } = useSidebar();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 1,
      }}
    >
      <Tooltip title={isCollapsed ? "Expand" : "Collapse"} placement="right">
        <IconButton
          onClick={toggleCollapse}
          sx={{
            width: 52,
            height: 52,
            color: colors.neutral[400],
            "&:hover": {
              backgroundColor: colors.neutral[800],
              color: colors.primary[400],
            },
          }}
        >
          {isCollapsed ? (
            <ChevronRight sx={{ fontSize: 34 }} />
          ) : (
            <ChevronLeft sx={{ fontSize: 34 }} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
